import { FC, PropsWithChildren, useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { useToast } from '../lib/chakraUi/hooks';

export const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const toast = useToast();

  useEffect(() => {
    const errorHandler: (error: ErrorEvent) => void = (error) => {
      /* ResizeObserver errors are tirggered by lastpass auto-fill injection.
      This stops the error without affecting auto-fill functionality. */
      if (error && error.message.includes('ResizeObserver')) {
        error.stopImmediatePropagation();
        return;
      }
      toast({
        title: 'An error occurred',
        description: 'Please try again later.',
        type: 'error',
        closable: false,
      });
      console.error(
        `Boundary error: ${error.message}\n\n${error.filename}:${error.lineno}`,
      );
      Sentry.captureException(
        `Boundary error: ${error.message}\n\n${error.filename}:${error.lineno}`,
      );
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, [toast]);

  return <>{children}</>;
};
